module.exports = __webpack_public_path__ + "static/media/menu-close.cc7158ec.svg";